export default __webpack_public_path__ + "static/media/footer-logo.22f842df.png";